import { Box, Button as MuiButton, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useForm } from './Context.js';
import { DataGridPremium } from '@mui/x-data-grid-premium';

export { useFormApi, default as Form } from './Context';
export { default as BusinessHours } from './BusinessHours';
export { default as Field } from './Field';
export { default as Section } from './Section';
export { Select, Option } from './Select';
export { default as Checkbox } from './Checkbox';
export {
  default as UploadImages,
  uploadImages,
  FilePreviewCarousel,
} from './UploadImages';
export { default as Map } from './Map';
export { default as Slider } from './Slider';
export { default as RichText } from './RichText';
export { UploadFileComponent } from 'src/hooks/useForm.js';
export * from './Dialogs';
export { DynamicForm, schemaFromFields } from './Dynamic';
export { DynamicFormEditor } from './DynamicEditor';
export { default as MonthDay } from './MonthDay';
export { default as ToggleField } from './ToggleField';

export function Row({ children, ...props }) {
  return (
    <Box display="flex" {...props}>
      {children}
    </Box>
  );
}

export function Button({ action, children, disabled = false, ...props }) {
  const form = useForm();

  if (['submit', 'cancel'].indexOf(action) === -1) {
    throw new Error("The `action` prop must be one of ['submit', 'cancel']");
  }

  switch (action) {
    case 'submit':
      return (
        <LoadingButton
          {...props}
          loading={form.isLoading || props.isLoading}
          onClick={() => form.onSubmit(form.state)}
          disabled={Boolean(disabled)}
        >
          {children}
        </LoadingButton>
      );

    case 'cancel':
      return (
        <MuiButton
          {...props}
          disabled={form.isLoading || Boolean(disabled)}
          onClick={() => form.onCancel()}
        >
          {children}
        </MuiButton>
      );

    default:
      throw new Error('Unreachable');
  }
}

export function DataGridList({ id, ...props }) {
  const form = useForm(id, []);

  return (
    <>
      {form.error && (
        <Typography color="red" variant="body2">
          {form.error}
        </Typography>
      )}
      <DataGridPremium
        rows={form.value ?? []}
        filterDebounceMs={500}
        {...props}
      />
    </>
  );
}
